<a
  class="d-inline-flex align-items-baseline text-grey supporting-text cursor-pointer"
  [queryParams]="queryParams"
  queryParamsHandling="merge"
  [routerLink]="[urlToNavigate]"
>
  <i class="icon-arrow-left small text-grey mr-1"></i>
  {{ text }}
</a>
